import React from "react";

export default function Footer() {
  return (
    <footer
      className="bg-light border-top py-5 mt-5 page-wrapper container-xxl"
      style={{ background: "#0d1f23" }}
    >
      <div className="">
        {/* ================= TOP GRID ================= */}
        <div className="row g-4">
          {/* -------- Office Info -------- */}
          <div className="col-md-3">
            <h3 className="fw-bold mb-3">Kryzen Biotech</h3>

            <p className="mb-2">
              <strong>Corporate Office:</strong>
              <br />
              M319, City Avenue, Pune-Bangalore Highway, Wakad, 411057
            </p>

            <p className="mb-2">
              <strong>Experience Centre:</strong>
              <br />
              #98, At. Po. Degaon, Satara, 412803
            </p>

            <p className="mb-2">
              <strong>Manufacturing:</strong>
              <br />
              #817, At. Po. Degaon, Satara, 412803
            </p>

            <p className="mb-3">
              <strong>Warehouses:</strong> Pune, Nashik, Aurangabad
            </p>

            <a
              href="https://kryzen.com/wp-content/uploads/2025/03/Kryzen-Brochure-2025_compressed-2.pdf"
              target="_blank"
              rel="noreferrer"
              className="btn btn-success w-100"
            >
              Download Brochure
            </a>
          </div>

          {/* -------- Company -------- */}
          <div className="col-md-3">
            <h4 className="fw-bold mb-3">Company</h4>
            <ul className="list-unstyled footer-links">
              <li>
                <a href="https://kryzen.com/about-us/">About Kryzen Biotech</a>
              </li>
              <li>
                <a href="https://kryzen.com/our-projects/">
                  Constructed Projects
                </a>
              </li>
              <li>
                <a href="https://kryzen.com/gallery/">Photo Gallery</a>
              </li>
              <li>
                <a href="https://kryzen.com/our-story/">Story of Kryzen</a>
              </li>
              <li>
                <a href="https://kryzen.com/customer-review/">
                  Customer Review
                </a>
              </li>
              <li>
                <a href="https://kryzen.com/hydroponic-masterclass/">
                  Hydroponic Masterclass
                </a>
              </li>
              <li>
                <a href="https://kryzen.com/farm-training/">
                  Hands On Farm Training
                </a>
              </li>
              <li>
                <a href="https://kryzen.com/contact-us/">Contact Us</a>
              </li>
              <li>
                <a href="https://kryzen.com/student-training/">
                  Student Training
                </a>
              </li>
            </ul>
          </div>

          {/* -------- Products -------- */}
          <div className="col-md-3">
            <h4 className="fw-bold mb-3">Products</h4>
            <ul className="list-unstyled footer-links">
              <li>
                <a href="https://kryzen.com/kryzen-polytunnel/">Polytunnel</a>
              </li>
              <li>
                <a href="https://kryzen.com/kryzen-nethouse-shadehouse/">
                  Nethouse / Shadehouse
                </a>
              </li>
              <li>
                <a href="https://kryzen.com/kryzen-naturally-ventilated-polyhouse/">
                  Naturally Ventilated Polyhouse
                </a>
              </li>
              <li>
                <a href="https://kryzen.com/kryzen-exhaust-fan-pad-controlled-environment-polyhouse/">
                  Fan & Pad Polyhouse
                </a>
              </li>
              <li>
                <a href="https://kryzen.com/kryzen-poly-carbonate/">
                  Polycarbonate House
                </a>
              </li>
              <li>
                <a href="https://kryzen.com/kryzen-vertical-hydroponic-farming/">
                  Vertical Hydroponic NFT
                </a>
              </li>
              <li>
                <a href="httpsryzen.com/kryzen-flat-nft-hydroponics/">
                  Flat Hydroponic NFT
                </a>
              </li>
              <li>
                <a href="https://kryzen.com/kryzen-soil-less-growbags/">
                  Soil-less Growbags
                </a>
              </li>
              <li>
                <a href="https://kryzen.com/kryzen-grow-buckets-dutch-buckets/">
                  Dutch Buckets
                </a>
              </li>
            </ul>
          </div>

          {/* -------- Services -------- */}
          <div className="col-md-3">
            <h4 className="fw-bold mb-3">Services</h4>
            <ul className="list-unstyled footer-links">
              <li>
                <a href="https://kryzen.com/kryzen-for-rural-farmer/">
                  Rural Farming Tech
                </a>
              </li>
              <li>
                <a href="https://kryzen.com/kryzen-for-urban-farmer/">
                  Urban Farming Tech
                </a>
              </li>
              <li>
                <a href="https://kryzen.com/kryzen-for-crop-research/">
                  Crop Research Lab
                </a>
              </li>
              <li>
                <a href="https://kryzen.com/kryzen-for-soil-less-growing/">
                  Soil-less Growing
                </a>
              </li>
              <li>
                <a href="https://kryzen.com/kryzen-for-mega-farming/">
                  Mega Farming Projects
                </a>
              </li>
              <li>
                <a href="https://kryzen.com/kryzen-for-agro-csr-plan/">
                  Agro CSR Planning
                </a>
              </li>
              <li>
                <a href="https://kryzen.com/kryzen-for-building-community/">
                  Kryzen Community
                </a>
              </li>
              <li>
                <a href="https://kryzen.com/kryzen-for-grants-subsidies/">
                  Grants & Subsidies
                </a>
              </li>
              <li>
                <a href="https://kryzen.com/hydroponic-nutrient-chart/">
                  Nutrient Chart
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* ================= CERTIFICATIONS ================= */}
        <div className="text-center mt-5">
          <a href="tel:9870424425">
            <img
              src="https://kryzen.com/wp-content/uploads/2024/10/16.png"
              alt="Phone"
              className="img-fluid mb-3"
              style={{ maxWidth: 350 }}
            />
          </a>

          <p className="mb-2">
            Kryzen Biotech Private Limited
            <br />
            CIN: U01100PN2019PTC186207 | GST: 27AAHCK7659R1ZF
          </p>

          <img
            src="https://kryzen.com/wp-content/uploads/2020/12/iso.png"
            alt="ISO"
            className="img-fluid"
          />
        </div>

        {/* ================= BOTTOM MENU ================= */}
        <div className="text-center mt-4 pt-3 border-top">
          <p>
            kryzen.info is an official digital property of Kryzen Biotech Pvt.
            Ltd.
            <hr className="m-0 m-3" />
          </p>
          <ul className="list-inline footer-links-small">
            <li className="list-inline-item">
              <a href="https://kryzen.com/our-team/">Our Team</a>
            </li>
            <li className="list-inline-item">
              <a href="https://kryzen.com/work-with-us/">Work With Us</a>
            </li>
            <li className="list-inline-item">
              <a href="https://kryzen.com/terms-condition/">
                Terms & Conditions
              </a>
            </li>
            <li className="list-inline-item">
              <a href="https://kryzen.com/privacy-policy/">Privacy Policy</a>
            </li>
          </ul>
        </div>
      </div>

      {/* Custom styling for footer */}
      <style>{`
        .footer-links li a {
          display: block;
          padding: 4px 0;
          color: #444;
          text-decoration: none;
        }
        .footer-links li a:hover {
          text-decoration: underline;
          color: #206bc4;
        }
        .footer-links-small a {
          margin: 0 10px;
          color: #555;
          text-decoration: none;
        }
        .footer-links-small a:hover {
          text-decoration: underline;
          color: #206bc4;
        }
      `}</style>
    </footer>
  );
}
